// extracted by mini-css-extract-plugin
export default {"intro_feature":"Home_intro_feature__veesU","button_red":"Home_button_red__WBTcA","box":"Home_box__X+JQg"};